module.exports = __webpack_public_path__ + "static/media/bananaKiwiIceCream.e8e0c79e.jpg";